import React from 'react';

import { Spacer } from '@zapier/design-system';

import List from '../../shared/List';
import RadioInput from '../../shared/RadioInput';
import Surface from '../../shared/Surface';
import { SizeType } from '../../../types';

type IconName = any;
type Item = { icon?: IconName; label: string; value: string };

type RadioBlockProps = {
  /** Title */
  title: string;
  /** Radio inputs to list */
  items: Item[];
  /** Function to call when the user clicks on an item. */
  onClick: (item: Item) => void;
  /** Size to display. */
  size?: SizeType;
};

const DEFAULT_ICON: IconName = 'navHelpFill';

/**
 * Renders a block with a list of items using the `RadioInput` component.
 */
const RadioBlock = ({
  title,
  items: items,
  onClick,
  size = 'large',
}: RadioBlockProps) => {
  const defaultIcon = items.find(item => !!item.icon)
    ? DEFAULT_ICON
    : undefined;

  return (
    <Surface size={size} title={title}>
      <Spacer height={20} />
      <List
        gap={5}
        itemRenderer={(item: Item) => (
          <RadioInput
            icon={item.icon || defaultIcon}
            label={item.label}
            onClick={() => onClick(item)}
          />
        )}
        items={items}
      />
    </Surface>
  );
};

export default RadioBlock;
